import $zWW1i$react from "react";
import {formatDistanceStrict as $zWW1i$formatDistanceStrict, format as $zWW1i$format, isSameDay as $zWW1i$isSameDay, addDays as $zWW1i$addDays} from "date-fns";
import {enUS as $zWW1i$enUS} from "date-fns/locale/index.js";




const $d6701b0fbe807987$var$formatDistanceLocale = {
    halfAMinute: "30s",
    xSeconds: "{{count}}s",
    lessThanXSeconds: "{{count}}s",
    xMinutes: "{{count}}m",
    lessThanXMinutes: "{{count}}m",
    aboutXHours: "{{count}}h",
    xHours: "{{count}}h",
    xDays: "{{count}}d",
    xWeeks: "{{count}}w",
    aboutXWeeks: "{{count}}w",
    xMonths: "{{count}}months",
    aboutXMonths: "{{count}}months",
    overXYears: "{{count}}y",
    aboutXYears: "{{count}}y",
    almostXYears: "{{count}}y",
    xYears: "{{count}}y"
};
function $d6701b0fbe807987$var$isNil(value) {
    return value === null || value === undefined;
}
function $d6701b0fbe807987$var$formatDistance(token, count) {
    return $d6701b0fbe807987$var$formatDistanceLocale[token].replace("{{count}}", count);
}
const $d6701b0fbe807987$var$BanjoContext = /*#__PURE__*/ (0, $zWW1i$react).createContext({});
function $d6701b0fbe807987$export$9fdaa8695662e93e() {
    return (0, $zWW1i$react).useContext($d6701b0fbe807987$var$BanjoContext);
}
function $d6701b0fbe807987$var$transformString(value) {
    return value;
}
function $d6701b0fbe807987$var$transformElapsedTime(value, { getRootTime: getRootTime  }) {
    const time = new Date(value);
    const rootTime = getRootTime();
    let distance = (0, $zWW1i$formatDistanceStrict)(rootTime, time, {
        locale: {
            ...(0, $zWW1i$enUS),
            formatDistance: $d6701b0fbe807987$var$formatDistance
        }
    });
    // override "months" to "days"
    if (distance.includes("months")) distance = (0, $zWW1i$formatDistanceStrict)(rootTime, time, {
        locale: {
            ...(0, $zWW1i$enUS),
            formatDistance: $d6701b0fbe807987$var$formatDistance
        },
        unit: "day"
    });
    return distance;
}
function $d6701b0fbe807987$var$transformDateShort(value) {
    const time = new Date(value);
    const string = (0, $zWW1i$format)(time, "MMM d");
    return string;
}
function $d6701b0fbe807987$var$transformDateMediumDay(value, { getRootTime: getRootTime  }) {
    const time = new Date(value);
    const rootTime = getRootTime();
    let string = (0, $zWW1i$format)(time, "EEEE, MMM d");
    const isToday = (0, $zWW1i$isSameDay)(rootTime, time);
    const isTomorrow = (0, $zWW1i$isSameDay)((0, $zWW1i$addDays)(rootTime, 1), time);
    if (isToday) string = string.replace(/[^,]*/, "Today");
    if (isTomorrow) string = string.replace(/[^,]*/, "Tomorrow");
    return string;
}
function $d6701b0fbe807987$var$transformDateMedium(value) {
    const time = new Date(value);
    const string = (0, $zWW1i$format)(time, "MMM d, yyyy");
    return string;
}
function $d6701b0fbe807987$var$transformDateMonthYear(value) {
    const time = new Date(value);
    const string = (0, $zWW1i$format)(time, "MMM, yyyy");
    return string;
}
function $d6701b0fbe807987$var$transformDateYear(value) {
    const time = new Date(value);
    const string = (0, $zWW1i$format)(time, "yyyy");
    return string;
}
function $d6701b0fbe807987$var$transformDayOfWeek(value) {
    const time = new Date(value);
    const string = (0, $zWW1i$format)(time, "E");
    return string;
}
function $d6701b0fbe807987$var$transformDayOfMonth(value) {
    const time = new Date(value);
    const string = (0, $zWW1i$format)(time, "d");
    return string;
}
function $d6701b0fbe807987$var$transformTimeLocal(value) {
    const time = new Date(value);
    const string = (0, $zWW1i$format)(time, "h:mm aaaa");
    return string;
}
function $d6701b0fbe807987$var$transformTimeLocalApprox(value) {
    const time = new Date(value);
    const string = "~" + (0, $zWW1i$format)(time, "h:mm aaaa");
    return string;
}
function $d6701b0fbe807987$var$transformCurrencyLong({ value: value , currency: currency  }, { locale: locale  }) {
    const string = value.toLocaleString(locale, {
        style: "currency",
        currency: currency
    });
    return string;
}
function $d6701b0fbe807987$var$transformCurrencyVanity({ value: value , currency: currency  }, { locale: locale  }) {
    const minimumFractionDigits = value === parseInt(value) ? 0 : 2;
    return value.toLocaleString(locale, {
        style: "currency",
        currency: currency,
        minimumFractionDigits: minimumFractionDigits
    });
}
function $d6701b0fbe807987$var$transformPercentLong(value, { locale: locale  }) {
    return Number(value.toFixed(2)).toLocaleString(locale, {
        minimumFractionDigits: 2
    }) + "%";
}
function $d6701b0fbe807987$var$transformPercentShort(value, { locale: locale  }) {
    return Number(value.toFixed(0)).toLocaleString(locale) + "%";
}
function $d6701b0fbe807987$var$transformCurrencyChangeLong({ value: value , currency: currency  }, { locale: locale  }) {
    const sign = value > 0 ? "+" : "";
    return sign + value.toLocaleString(locale, {
        style: "currency",
        currency: currency
    });
}
function $d6701b0fbe807987$var$transformPercentChangeLong(value, { locale: locale  }) {
    const sign = value > 0 ? "+" : "";
    return sign + (Number(value.toFixed(2)).toLocaleString(locale, {
        minimumFractionDigits: 2
    }) + "%");
}
function $d6701b0fbe807987$var$transformNumberLong(value, { locale: locale  }) {
    return Number(value.toFixed(2)).toLocaleString(locale, {
        minimumFractionDigits: 2
    });
}
function $d6701b0fbe807987$var$transformInteger(value) {
    return Number(value);
}
const $d6701b0fbe807987$var$interpolateFunctionMap = {
    string: $d6701b0fbe807987$var$transformString,
    elapsedTime: $d6701b0fbe807987$var$transformElapsedTime,
    dateShort: $d6701b0fbe807987$var$transformDateShort,
    dateMediumDay: $d6701b0fbe807987$var$transformDateMediumDay,
    dateMedium: $d6701b0fbe807987$var$transformDateMedium,
    dateMonthYear: $d6701b0fbe807987$var$transformDateMonthYear,
    dateYear: $d6701b0fbe807987$var$transformDateYear,
    dayOfWeek: $d6701b0fbe807987$var$transformDayOfWeek,
    dayOfMonth: $d6701b0fbe807987$var$transformDayOfMonth,
    timeLocal: $d6701b0fbe807987$var$transformTimeLocal,
    timeLocalApprox: $d6701b0fbe807987$var$transformTimeLocalApprox,
    currencyLong: $d6701b0fbe807987$var$transformCurrencyLong,
    currencyVanity: $d6701b0fbe807987$var$transformCurrencyVanity,
    percentLong: $d6701b0fbe807987$var$transformPercentLong,
    percentShort: $d6701b0fbe807987$var$transformPercentShort,
    currencyChangeLong: $d6701b0fbe807987$var$transformCurrencyChangeLong,
    percentChangeLong: $d6701b0fbe807987$var$transformPercentChangeLong,
    numberLong: $d6701b0fbe807987$var$transformNumberLong,
    integer: $d6701b0fbe807987$var$transformInteger,
    link: null
};
function $d6701b0fbe807987$export$2d101db3c1e74fd1(stringObj, variants) {
    for (const variant of variants){
        const variantObj = stringObj.default.variants[variant];
        if (variantObj) return variantObj;
    }
    return stringObj.default;
}
function $d6701b0fbe807987$export$15ec9472ff2d721(inputObject, data, config) {
    const { text: text , variables: variables = {} , linkVariables: linkVariables = {}  } = inputObject;
    const regex = /(\{\{(\w+)\}\})/g;
    return text.split(regex).reduce((acc, segment, index, segments)=>{
        if (segment.startsWith("{{") && segment.endsWith("}}")) {
            const variableName = segments[index + 1];
            // Handle regular variables
            if (variables[variableName]) {
                let value = data?.[variableName];
                let wrapperFn;
                if (value?.wrapper) {
                    wrapperFn = value.wrapper;
                    value = value.value;
                }
                const variableType = variables[variableName].type;
                if (!$d6701b0fbe807987$var$interpolateFunctionMap[variableType]) throw new Error(`Variable type '${variableType}' not supported.`);
                if ($d6701b0fbe807987$var$isNil(value) || value.hasOwnProperty("value") && ($d6701b0fbe807987$var$isNil(value.value) || value.value === "")) {
                    if ("fallback" in variables[variableName]) value = variables[variableName].fallback;
                    else throw new Error(`No data or fallback for variable '${variableName}'.`);
                } else // Apply interpolation function
                value = $d6701b0fbe807987$var$interpolateFunctionMap[variableType](value, config);
                return [
                    ...acc,
                    {
                        kind: "variable",
                        id: variableName,
                        ...variables[variableName],
                        text: value,
                        ...wrapperFn ? {
                            wrapperFn: wrapperFn
                        } : {}
                    }, 
                ];
            }
            // Handle link variables
            if (linkVariables[variableName]) {
                const wrapperFn1 = data?.[variableName]?.wrapper;
                return [
                    ...acc,
                    {
                        kind: "link",
                        id: variableName,
                        ...linkVariables[variableName],
                        ...wrapperFn1 ? {
                            wrapperFn: wrapperFn1
                        } : {}
                    }, 
                ];
            }
            // If variable is not found in either
            throw new Error(`Variable or linkVariable '${variableName}' not found in either reference objects.`);
        }
        if (segment && index % 3 === 0) return [
            ...acc,
            {
                kind: "text",
                text: segment
            }, 
        ];
        return acc;
    }, []);
}
function $d6701b0fbe807987$var$findStringObj(json, variants = [], stringId) {
    const stringObj = json.components[stringId];
    if (!stringObj) {
        console.error("Banjo: ERROR finding stringId:", stringId);
        return null;
    }
    // select text from proper variant (if string has variants)
    return stringObj.default.variants ? $d6701b0fbe807987$export$2d101db3c1e74fd1(stringObj, variants) : stringObj.default;
}
function $d6701b0fbe807987$export$81e7834516584f30(json, variants = [], config) {
    return function getRichText(stringId, data) {
        const stringObj = $d6701b0fbe807987$var$findStringObj(json, variants, stringId);
        if (!stringObj) return null;
        return $d6701b0fbe807987$export$15ec9472ff2d721(stringObj, data, config);
    };
}
function $d6701b0fbe807987$export$2c12cef35b10c8d(json, variants = [], config) {
    return function getCopy(stringId, data, classNames, openLinksInNewWindow = false) {
        const getRichText = $d6701b0fbe807987$export$81e7834516584f30(json, variants, config);
        const text = getRichText(stringId, data);
        if (!text) console.error(`Banjo: ERROR finding text from ${stringId}`);
        return /*#__PURE__*/ (0, $zWW1i$react).createElement("span", {
            "data-testid": stringId
        }, text?.map((textSegment, index)=>{
            const className = classNames?.[textSegment.kind];
            const key = `${stringId}${index}`;
            switch(textSegment.kind){
                case "text":
                case "variable":
                    {
                        const content = textSegment.wrapperFn ? textSegment.wrapperFn({
                            value: textSegment.text
                        }) : textSegment.text;
                        return className ? /*#__PURE__*/ (0, $zWW1i$react).createElement("span", {
                            key: key,
                            className: className
                        }, content) : textSegment.wrapperFn ? /*#__PURE__*/ (0, $zWW1i$react).createElement((0, $zWW1i$react).Fragment, {
                            key: key
                        }, content) : content;
                    }
                case "link":
                    {
                        const content1 = textSegment.wrapperFn ? textSegment.wrapperFn({
                            value: textSegment.text,
                            url: textSegment.url
                        }) : textSegment.text;
                        return textSegment.wrapperFn ? className ? /*#__PURE__*/ (0, $zWW1i$react).createElement("span", {
                            key: key,
                            className: className
                        }, content1) : /*#__PURE__*/ (0, $zWW1i$react).createElement((0, $zWW1i$react).Fragment, {
                            key: key
                        }, content1) : /*#__PURE__*/ (0, $zWW1i$react).createElement("a", {
                            key: key,
                            className: className,
                            href: textSegment.url,
                            "data-testid": key,
                            rel: "noopener noreferrer",
                            target: openLinksInNewWindow ? "_blank" : "_self"
                        }, textSegment.text);
                    }
                default:
                    console.error(`Banjo: ERROR finding textSegment(${textSegment.kind}) from ${stringId}`);
                    return null;
            }
        }));
    };
}
function $d6701b0fbe807987$export$ad0ad5911bef4ad7(json, variants = [], config) {
    return function getString(stringId, data) {
        const getRichText = $d6701b0fbe807987$export$81e7834516584f30(json, variants, config);
        const text = getRichText(stringId, data);
        if (!text) console.error(`Banjo: ERROR finding text from ${stringId}`);
        return text?.map((textSegment)=>{
            switch(textSegment.kind){
                case "text":
                case "variable":
                    return textSegment.text;
                case "link":
                    console.error(`Banjo: ERROR Cannot textSegment(${textSegment.kind}) from ${stringId} as a string`);
                    return null;
                default:
                    console.error(`Banjo: ERROR finding textSegment(${textSegment.kind}) from ${stringId}`);
                    return null;
            }
        }).join("");
    };
}
const $d6701b0fbe807987$var$getRootTime = ()=>new Date();
function $d6701b0fbe807987$export$8d1d3e13c1a69614(props) {
    const [locale, setLocale] = (0, $zWW1i$react).useState(props.defaultLocale);
    const localizedJson = props.languageMap[locale];
    const getCopy = $d6701b0fbe807987$export$2c12cef35b10c8d(localizedJson, props.variants, {
        locale: locale,
        getRootTime: $d6701b0fbe807987$var$getRootTime
    });
    const getRichText = $d6701b0fbe807987$export$81e7834516584f30(localizedJson, props.variants, {
        locale: locale,
        getRootTime: $d6701b0fbe807987$var$getRootTime
    });
    const getString = $d6701b0fbe807987$export$ad0ad5911bef4ad7(localizedJson, props.variants, {
        locale: locale,
        getRootTime: $d6701b0fbe807987$var$getRootTime
    });
    return /*#__PURE__*/ (0, $zWW1i$react).createElement($d6701b0fbe807987$var$BanjoContext.Provider, {
        value: {
            getCopy: getCopy,
            getRichText: getRichText,
            getString: getString,
            localizedJson: localizedJson,
            locale: locale,
            setLocale: setLocale,
            version: localizedJson.version
        }
    }, props.children);
}
$d6701b0fbe807987$export$8d1d3e13c1a69614.defaultProps = {
    defaultLocale: "en-us"
};
const $d6701b0fbe807987$export$b45635b0957e00e4 = (Component)=>(props)=>/*#__PURE__*/ (0, $zWW1i$react).createElement($d6701b0fbe807987$var$BanjoContext.Consumer, null, (contextProps)=>/*#__PURE__*/ (0, $zWW1i$react).createElement(Component, {
                ...contextProps,
                ...props
            }));
function $d6701b0fbe807987$export$e4be388e1a63864(props) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore-next-line
    const text = $d6701b0fbe807987$export$9fdaa8695662e93e().getCopy(props.stringId, props.data, props.classNames, props.openLinksInNewWindow) ?? null;
    return text;
}




export {$d6701b0fbe807987$export$9fdaa8695662e93e as useBanjo, $d6701b0fbe807987$export$8d1d3e13c1a69614 as BanjoProvider, $d6701b0fbe807987$export$b45635b0957e00e4 as withBanjoContext, $d6701b0fbe807987$export$e4be388e1a63864 as BanjoString, $d6701b0fbe807987$export$2c12cef35b10c8d as getCopyLocale, $d6701b0fbe807987$export$ad0ad5911bef4ad7 as getStringLocale};
//# sourceMappingURL=index.js.map
